import { render } from "./PreferredBranchesDropdown.vue?vue&type=template&id=4a05e930&ts=true"
import script from "./PreferredBranchesDropdown.vue?vue&type=script&lang=ts"
export * from "./PreferredBranchesDropdown.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__